<template>
  <div class="groups_table grey loading_table">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="name"
      ref="table"
      pagination-simple
      per-page="15"
      :data="usersList"
      paginated
      checkable
      :checked-rows.sync="checked.users"
      @page-change="changePage"
      backend-pagination
      :total="totalCount"
      detailed
      :show-detail-icon="false"
      @click="openInfo"
    >
      <template slot-scope="props">
        <b-table-column label="ФИО" :visible="true" field="name" :centered="false" width="30%">
          <div>{{ `${props.row.surname} ${props.row.name} ${props.row.patronymic}` }}</div>
        </b-table-column>
        <b-table-column label="Филиал" :visible="true" field="branch_id" :centered="false" width="25%">
          <div>{{ props.row.branch.name }}</div>
        </b-table-column>
        <b-table-column label="Зарегистрирован" :visible="true" field="created_at" :centered="false" width="20%">
          <div>{{ props.row.created_at | moment('DD.MM.YYYY') }}</div>
        </b-table-column>
        <b-table-column label="Логин" :visible="true" field="email" :centered="false" width="20%">
          <div>{{ props.row.email }}</div>
        </b-table-column>
      </template>

      <template slot="detail" slot-scope="props">
        <div class="table_actions">
          <button class="delete_course" @click="$emit('detach', [props.row.id])">
            <i class="mdi mdi-account-remove-outline"></i> Удалить
          </button>
          <button class="double_course" v-if="!props.row.deleted_at" @click="openUserPage(props.row)">
            <router-link :to="'/all-users/' + props.row.id">
              <i class="mdi mdi-account-edit"></i> Редактировать/смотреть пользователя
            </router-link>
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    usersList: {
      default: () => [],
      type: Array,
    },
    checked: {
      default: () => {},
      type: Object,
    },
    search: {
      default: () => {},
      type: Object,
    },
    totalCount: {
      default: () => 0,
      type: Number,
    },
    isLoading: {
      default: () => true,
      type: Boolean,
    },
  },
  data() {
    return {
      openedRow: {},
    }
  },
  methods: {
    openInfo(row) {
      if (row != this.openedRow) {
        this.$refs.table.toggleDetails(this.openedRow);
        this.$refs.table.toggleDetails(row);
        this.openedRow = row;
        return;
      }
      this.$refs.table.toggleDetails(row);
      this.openedRow = {};
    },
    changePage(val) {
      this.search.groupUsersPage = val;
      this.$emit('changePage');
    },
    openUserPage(val) {
      if (this.$browserDetect.isIE) {
        this.$router.push('/all-users/' + val.id);
      }
    },
  },
}
</script>
